import { jsx as _jsx } from "react/jsx-runtime";
import { AdvantagesSection } from '../../advantages-section/AdvantagesSectionV2';
import { TextSize } from '@as/cotopaxi';
const AdvantagesBlock = ({ advantages }) => {
    if (!(advantages === null || advantages === void 0 ? void 0 : advantages.length))
        return null;
    return _jsx(AdvantagesSection, { items: advantages, textSize: TextSize.MEDIUM });
};
export default AdvantagesBlock;
